import { searchAssignableUsers } from 'api/admin/userPermissions/searchAssignableUsers'

export async function fetchAssignableUsers(keyword: string) {
  return searchAssignableUsers({ keyword })
}
